import Swiper from 'swiper/bundle'
import onPageLoad from './onPageLoad'

function initBrokersSection() {
  const sections = document.querySelectorAll('.sale-brokers')
  const popup = document.querySelector('.sale-popup')
  const popupInput = document.querySelector(
    '.sale-popup input[name="contact_form[broker_email]"]'
  )
  const popupClose = document.querySelectorAll('.sale-popup-close')

  if (!sections.length) return

  sections.forEach(section => {
    const mapLinks = section.querySelectorAll('[data-highlight-link]')
    const sliderWrapp = section.querySelector('.sale-brokers-slider')

    const swiper = new Swiper(section.querySelector('.swiper-container'), {
      slidesPerView: 1.2,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.2,
        },
      },
    })

    mapLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault()
        const activeItemsId = this.getAttribute('data-highlight-carousel-items')

        if (this.classList.contains('button')) {
          mapLinks.forEach(item => {
            item.classList.remove('button__brand')
          })
          this.classList.add('button__brand')
        }
        section.querySelectorAll('[data-map-id]').forEach(item => {
          if (item.getAttribute('data-map-id') === activeItemsId) {
            item.classList.remove('hide')
          } else {
            item.classList.add('hide')
          }
        })

        sliderWrapp.classList.add('show')

        swiper.update()
      })
    })

    const slides = section.querySelectorAll(
      '.sale-brokers-slider .swiper-slide'
    )
    slides.forEach(slide => {
      slide.addEventListener('click', function() {
        const email = slide
          .querySelector('a[href^="mailto:"]')
          .href.replace('mailto:', '')
        popupInput.value = email || ''
        console.log('popupInput.value: ', popupInput.value)
        document.body.classList.add('overflow-hidden')
        popup.classList.add('show')
      })
    })
  })

  popupClose.forEach(close => {
    close.addEventListener('click', function() {
      // add body overflow hiden
      document.body.classList.remove('overflow-hidden')
      popup.classList.remove('show')
    })
  })

  onPageLoad(popup)
}

function scrollTo() {
  const links = document.querySelectorAll('[data-scroll-to-section]')
  if (!links.length) return

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault()
      const sectionId = this.getAttribute('href').replace('#', '')
      const section = document.querySelector(`#${sectionId}`)
      const sectionOffset = section.offsetTop
      window.scrollTo({
        top: sectionOffset,
        behavior: 'smooth',
      })
    })
  })
}

export default function initSaleProcessPage() {
  initBrokersSection()
  scrollTo()
}
